import { apiSlice } from "../stores/base/api-slice";

const userEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
        postHelpMessage: builder.mutation<{ status: string }, any>({
			query: request => ({
				url: `/user/need-help`,
				method: "POST",
                body: request,
			}),
		}),
	})
});

export const { 
	usePostHelpMessageMutation
} = userEndpoints;
